/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom'
import styles from './styles.module.css'

import { useContext, useEffect, useRef, useState } from 'react'

// import { StarIcon } from '../../../assets/svgs/icons'
import Lottie from 'lottie-react'
import starAnimated from '../../../assets/lottie/star.json'

import { useTranslation } from 'react-i18next'
import { useEventMap } from '../../../hooks/useEventMap'
import {
  UserAccountsService,
  UserSatisfactionService
} from '../../../services'
// import { FirstMissionContext } from '../../../contexts/userMissions/CheckUserMissionContext'

function StepPublicationSuccess({ imageUrl, publicationIdRef }) {
  const { t } = useTranslation()
  const navigation = useNavigate()
  // const {handleCheckMissionStatus, userMissionStatus} = useContext(FirstMissionContext)
  const ratingRef = useRef(undefined)
  
  const { registerEvent } = useEventMap()
  const dataEvent = {
    event: 'new_publication_user_satisfaction_page_visualized',
    eventData: {
      origin: 'new_publication_page_my_publication',
      step: 'publication_success',
    },
  }
  useEffect(() => {
    registerEvent(dataEvent)
  }, [])

  const publicationSuccessFinish = async (route) => {
    if (publicationIdRef.current && ratingRef.current) {
      await UserSatisfactionService.postUserSatisfaction({
        userRating: ratingRef.current,
        userComment: '',
        origin: 'myPublication',
      })

    }

   
    // if(userMissionStatus === 'secondMissionDone'){
    //   await UserAccountsService.putUserMissionStatus({ userMissionStatus:'allDone'})
    // }

    // await handleCheckMissionStatus()
    navigation(route)
  }

  const StarRating = () => {
    const [rating, setRating] = useState(0)

    const lottieRefs1 = useRef()
    const lottieRefs2 = useRef()
    const lottieRefs3 = useRef()
    const lottieRefs4 = useRef()
    const lottieRefs5 = useRef()

    const handleClick = (index) => {
      setRating(index + 1)
    }

    useEffect(() => {
      if (rating === 1) {
        ratingRef.current = 1

        lottieRefs1.current.goToAndPlay(29, true)

        lottieRefs2.current.stop()
        lottieRefs3.current.stop()
        lottieRefs4.current.stop()
        lottieRefs5.current.stop()
      } else if (rating === 2) {
        ratingRef.current = 2

        lottieRefs1.current.goToAndPlay(29, true)
        lottieRefs2.current.goToAndPlay(29, true)

        lottieRefs3.current.stop()
        lottieRefs4.current.stop()
        lottieRefs5.current.stop()
      } else if (rating === 3) {
        ratingRef.current = 3

        lottieRefs1.current.goToAndPlay(29, true)
        lottieRefs2.current.goToAndPlay(29, true)
        lottieRefs3.current.goToAndPlay(29, true)

        lottieRefs4.current.stop()
        lottieRefs5.current.stop()
      } else if (rating === 4) {
        ratingRef.current = 4

        lottieRefs1.current.goToAndPlay(29, true)
        lottieRefs2.current.goToAndPlay(29, true)
        lottieRefs3.current.goToAndPlay(29, true)
        lottieRefs4.current.goToAndPlay(29, true)

        lottieRefs5.current.stop()
      } else if (rating === 5) {
        ratingRef.current = 5

        lottieRefs1.current.goToAndPlay(29, true)
        lottieRefs2.current.goToAndPlay(29, true)
        lottieRefs3.current.goToAndPlay(29, true)
        lottieRefs4.current.goToAndPlay(29, true)
        lottieRefs5.current.goToAndPlay(29, true)
      }
    }, [rating])

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          // gap: 8, // Espaçamento entre as estrelas
        }}
      >
        {[0, 1, 2, 3, 4].map((index) => (
          <div
            style={{
              width: 40,
              height: 40,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              position: 'relative',
            }}
            key={index}
            onClick={() => handleClick(index)}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-48%, -46%) scale(1.8)', // Aumenta a animação sem aumentar a área clicável
              }}
            >
              <Lottie
                lottieRef={
                  index === 0
                    ? lottieRefs1
                    : index === 1
                      ? lottieRefs2
                      : index === 2
                        ? lottieRefs3
                        : index === 3
                          ? lottieRefs4
                          : lottieRefs5
                }
                animationData={starAnimated}
                style={{ width: 50, height: 50 }}
                loop={false}
                autoplay={false}
              />
            </div>
          </div>
        ))}
      </div>
    )
  }

  const ContentRender = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',

          gap: 20,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              fontSize: 26,
              fontFamily: 'Poppins',
              fontWeight: 500,
            }}
          >
            {t('stepPublicationSuccess.congratulations')}
          </div>

          <div
            style={{
              fontSize: 26,
              fontFamily: 'Poppins',
              fontWeight: 700,
            }}
          >
            {t('stepPublicationSuccess.publicationScheduledSuccessfully')}
          </div>
        </div>

        <div style={{}}>
          <img
            src={imageUrl}
            style={{
              width: 220,
              height: 220,
              objectFit: 'contain',
              borderRadius: 10,

              boxShadow: '14.7px 14.7px 29.4px 0px #00000026',
            }}
            //onContextMenu={(e) => e.preventDefault()}
          />
        </div>

        <p style={{ margin: 0, color: '#898989', fontSize: '18px' }}>
          {t('stepPublicationSuccess.experience')}
        </p>
        <StarRating />

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 20,
          
          }}
        >
          <div
            style={{
              boxShadow: '0px 14px 40px 2px #6A009880',
              borderRadius: '40px',
            }}
          >
            <button
            // style={{
            //   border: '1px solid #6A0098',
            //   padding: '6px 20px',
            //   borderRadius: 20,
            //   cursor: 'pointer',

              //   userSelect: 'none',

              //   fontSize: 16,
              //   fontFamily: 'Poppins',
              //   fontWeight: 500,
              //   color: '#6A0098',
              // }}
              className={styles.button_new_post}
              onClick={async () => {
              // navigation('/ChatSocket')
              //publicationSuccessFinish('/ChatSocket')
                await UserSatisfactionService.postUserSatisfaction({
                  userRating: ratingRef.current,
                  userComment: '',
                  origin: 'myPublication',
                })
                
                // if(userMissionStatus === 'secondMissionDone'){
                //   await UserAccountsService.putUserMissionStatus({ userMissionStatus:'allDone'})
                // }

                // await handleCheckMissionStatus()
              
                navigation('/ChatSocket')
              }}
            >
              {t('stepPublicationSuccess.scheduleNewPublication')}
            </button>
          </div>

          <button
            onClick={() => {
              // navigation('/ChatSocket')
              publicationSuccessFinish('/SchedulePublicationPage')
            }}
            // style={{
            //   backgroundColor: '#6A0098',
            //   padding: '8px 10px',
            //   borderRadius: 4,
            //   cursor: 'pointer',

            //   userSelect: 'none',

            //   fontSize: 16,
            //   fontFamily: 'Poppins',
            //   fontWeight: 500,
            //   color: '#fff',
            // }}
            className={styles.button_schedule}
          >
            {t('stepPublicationSuccess.goToSchedule')}
          </button>
        </div>
      </div>
    )
  }

  return <div className={styles.container_header}>{ContentRender()}</div>
}

export default StepPublicationSuccess
